'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _FormInput = require('../FormInput');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineItemQuantitySelect = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(LineItemQuantitySelect, _React$Component);

  function LineItemQuantitySelect(props, context) {
    (0, _classCallCheck3.default)(this, LineItemQuantitySelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LineItemQuantitySelect.__proto__ || (0, _getPrototypeOf2.default)(LineItemQuantitySelect)).call(this, props, context));

    _this.state = {
      quantity: _this.props.quantity
    };
    return _this;
  }

  (0, _createClass3.default)(LineItemQuantitySelect, [{
    key: 'inputdefaults',
    value: function inputdefaults() {
      return {
        id: 'order_line_item_attribute_' + this.props.index + '_quantity',
        name: 'order[line_items_attributes][' + this.props.index + '][quantity]'
      };
    }
  }, {
    key: 'handleClickDown',
    value: function handleClickDown(e) {
      var _this2 = this;

      e.preventDefault();
      this.setState({
        quantity: this.state.quantity - 1
      }, function () {
        _this2.props.onChange(e);
      });
    }
  }, {
    key: 'handleClickUp',
    value: function handleClickUp(e) {
      var _this3 = this;

      e.preventDefault();
      this.setState({
        quantity: this.state.quantity + 1
      }, function () {
        _this3.props.onChange(e);
      });
    }
  }, {
    key: 'renderQuantity',
    value: function renderQuantity() {
      var _context;

      return _react2.default.createElement(_FormInput.Input, (0, _extends3.default)({}, this.inputdefaults(), {
        value: this.state.quantity,
        onChange: (_context = this.props).onChange.bind(_context),
        styleName: 'lineItemQuantitySelect__input'
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { styleName: 'lineItem__quantitySelect' },
        _react2.default.createElement(
          'label',
          {
            styleName: 'lineItemQuantity__label',
            className: 'hidden-md-up',
            htmlFor: 'order_line_item_attribute_' + this.props.index + '_quantity'
          },
          t('spree.quantity')
        ),
        _react2.default.createElement('br', { className: 'hidden-md-up' }),
        _react2.default.createElement(
          _FormInput.Button,
          {
            id: 'decreaseQuantity',
            onClick: this.handleClickDown.bind(this),
            styleName: 'lineItemQuantitySelect__button lineItemQuantitySelect__button-decrease'
          },
          '-'
        ),
        this.renderQuantity(),
        _react2.default.createElement(
          _FormInput.Button,
          {
            id: 'increaseQuantity',
            onClick: this.handleClickUp.bind(this),
            styleName: 'lineItemQuantitySelect__button'
          },
          '+'
        )
      );
    }
  }]);
  return LineItemQuantitySelect;
}(_react2.default.Component), _class2.propTypes = {
  id: _react.PropTypes.number.isRequired,
  quantity: _react.PropTypes.number.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  showInput: _react.PropTypes.bool
}, _class2.defaultProps = {
  showInput: false
}, _temp)) || _class) || _class);
exports.default = LineItemQuantitySelect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/LineItemQuantitySelect/index.js
// module id = 2477
// module chunks = 0